import React from 'react';
import {
  Dealer,
  IDealerCTA,
  IDealerLocatorLabels,
} from 'interfaces/dealerLocator';
import { useStyles } from './DealerDetails.styles';
import { Grid, useTheme } from '@mui/material';
import {
  LinkButton,
  LinkButtonType,
} from 'components/Global/LinkButton/LinkButton';
import { Icon, Icons } from 'components/Global/Icon/Icon';
import { appPalette } from 'theme/App.palette';
import { DealerMap } from 'components/DealerLocator/DealerMap/DealerMap';
import { DealerCard } from 'components/DealerLocator/DealerCard/DealerCard';
import { DealerDepartments } from 'components/DealerLocator/DealerDepartments/DealerDepartments';
import { DealerBadges } from 'components/DealerLocator/DealerBadges/DealerBadges';
import TextRender from 'components/Global/TextRender/TextRender';

export interface IDealerDetails {
  detailedDealer?: Dealer;
  dealerIndex: number;
  isEmbedded?: boolean;
  handleBackToDealerList: Function;
  labels: IDealerLocatorLabels;
  CTAs: { [key: string]: IDealerCTA };
  noMap?: boolean; // For testing;
  isInModal?: boolean;
}
export function DealerDetails({
  dealerIndex,
  detailedDealer,
  handleBackToDealerList,
  labels,
  CTAs,
  isEmbedded,
  noMap,
  isInModal,
}: IDealerDetails) {
  const classes = useStyles();
  const theme = useTheme();
  const isHondaThemed = theme.themeName === 'honda';
  const { acura_red, honda_blue } = appPalette.colors;
  if (detailedDealer) {
    detailedDealer.customMapIndex = dealerIndex;
    return (
      <Grid
        container
        direction="row"
        className={`${classes.root} dealer-details`}
      >
        <Grid item xs={12} className={classes.root}>
          <LinkButton
            variant={LinkButtonType.text}
            onClick={() => {
              handleBackToDealerList();
            }}
            classNames={{
              container: `${classes.back_to_container}`,
              ...(theme.themeName === 'honda' && {
                font: 'atm-paragraph-9',
              }),
            }}
          >
            <Icon
              type={Icons.caretLeft}
              color={isHondaThemed ? honda_blue : acura_red}
              className={classes.back_to_link_icon}
            />
            <span className={classes.back_to_link}>
              <TextRender text={labels.backToResults} />
            </span>
          </LinkButton>
        </Grid>
        <Grid item container xs={12} justifyContent="flex-end">
          <Grid item xs={12} md={6} className={classes.dealerInfoContainer}>
            <DealerCard
              CTAs={CTAs}
              labels={labels}
              isDealerDetail={true}
              index={dealerIndex}
              dealer={detailedDealer}
              useDealerCtas={!isEmbedded}
              handleDetailsClick={() => {}}
              isInModal={isInModal}
            />
            <DealerDepartments labels={labels} dealer={detailedDealer} />
            <DealerBadges dealer={detailedDealer} />
          </Grid>
          <Grid item xs={12} md className={classes.dealerMapContainer}>
            {!noMap && (
              <DealerMap
                dealers={[detailedDealer]}
                isEmbedded={true}
                hideSearchThisAreaButton={true}
                hideInfobox={true}
                labels={labels}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return <></>;
  }
}
